var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { createStore } from 'vuex';
// 定义本地存储 key
var STORAGE_KEYS = {
    REMEMBER_ME: 'app_remember_me',
    LOGIN_INFO: 'app_login_info',
    USER_INFO: 'app_user_info',
    ACCESS_TOKEN: 'app_access_token',
    REFRESH_TOKEN: 'app_refresh_token',
    WEBSITE_ID: 'app_website_id',
    // 保留原有签到和皮肤相关的keys
    THEME: 'app_theme',
    LAST_SIGN_IN_DATE: 'app_last_sign_in_date'
};
// 定义过期时间（毫秒）
var EXPIRATION_TIMES = {
    LOGIN_INFO: 30 * 24 * 60 * 60 * 1000,
    USER_INFO: 15 * 24 * 60 * 60 * 1000,
    ACCESS_TOKEN: 10 * 60 * 1000,
    REFRESH_TOKEN: 5 * 24 * 60 * 60 * 1000 // 5天
};
// 工具函数：获取带过期时间的本地存储数据
var getStorageItem = function (key) {
    var item = localStorage.getItem(key);
    if (!item)
        return null;
    try {
        var parsedItem = JSON.parse(item);
        // 检查是否过期
        if (parsedItem.expiry && parsedItem.expiry < Date.now()) {
            localStorage.removeItem(key);
            return null;
        }
        return parsedItem.value;
    }
    catch (e) {
        return null;
    }
};
// 工具函数：设置带过期时间的本地存储数据
var setStorageItem = function (key, value, expiryTime) {
    if (expiryTime === void 0) { expiryTime = null; }
    var item = {
        value: value,
        expiry: expiryTime ? Date.now() + expiryTime : null
    };
    localStorage.setItem(key, JSON.stringify(item));
};
// 工具函数：移除本地存储数据
var removeStorageItem = function (key) {
    localStorage.removeItem(key);
};
export default createStore({
    state: {
        rememberMe: getStorageItem(STORAGE_KEYS.REMEMBER_ME) || false,
        loginInfo: getStorageItem(STORAGE_KEYS.LOGIN_INFO) || null,
        userInfo: getStorageItem(STORAGE_KEYS.USER_INFO) || null,
        accessToken: getStorageItem(STORAGE_KEYS.ACCESS_TOKEN) || null,
        refreshToken: getStorageItem(STORAGE_KEYS.REFRESH_TOKEN) || null,
        websiteId: getStorageItem(STORAGE_KEYS.WEBSITE_ID) || process.env.VUE_APP_SiteID || '114',
        // 保留原有状态
        theme: getStorageItem(STORAGE_KEYS.THEME) || 'light',
        lastSignInDate: getStorageItem(STORAGE_KEYS.LAST_SIGN_IN_DATE) || null
    },
    getters: {
        isLoggedIn: function (state) { return !!state.accessToken; },
        getLoginInfo: function (state) { return state.loginInfo; },
        getUserInfo: function (state) { return state.userInfo; },
        getAccessToken: function (state) { return state.accessToken; },
        getRefreshToken: function (state) { return state.refreshToken; },
        getRememberMe: function (state) { return state.rememberMe; },
        getWebsiteId: function (state) { return state.websiteId; },
        // 保留原有getters
        getTheme: function (state) { return state.theme; },
        getLastSignInDate: function (state) { return state.lastSignInDate; }
    },
    mutations: {
        // 记住我
        SET_REMEMBER_ME: function (state, payload) {
            state.rememberMe = payload;
            setStorageItem(STORAGE_KEYS.REMEMBER_ME, payload);
        },
        // 登录信息
        SET_LOGIN_INFO: function (state, payload) {
            state.loginInfo = payload;
            if (payload && state.rememberMe) {
                setStorageItem(STORAGE_KEYS.LOGIN_INFO, payload, EXPIRATION_TIMES.LOGIN_INFO);
            }
            else if (!payload) {
                removeStorageItem(STORAGE_KEYS.LOGIN_INFO);
            }
        },
        // 用户信息
        SET_USER_INFO: function (state, payload) {
            state.userInfo = payload;
            setStorageItem(STORAGE_KEYS.USER_INFO, payload, EXPIRATION_TIMES.USER_INFO);
        },
        SET_ACCESS_TOKEN: function (state, payload) {
            state.accessToken = payload;
            if (payload) {
                setStorageItem(STORAGE_KEYS.ACCESS_TOKEN, payload, EXPIRATION_TIMES.ACCESS_TOKEN);
            }
            else {
                removeStorageItem(STORAGE_KEYS.ACCESS_TOKEN);
            }
        },
        // 刷新令牌
        SET_REFRESH_TOKEN: function (state, payload) {
            state.refreshToken = payload;
            if (payload) {
                setStorageItem(STORAGE_KEYS.REFRESH_TOKEN, payload, EXPIRATION_TIMES.REFRESH_TOKEN);
            }
            else {
                removeStorageItem(STORAGE_KEYS.REFRESH_TOKEN);
            }
        },
        // 设置网站ID
        SET_WEBSITE_ID: function (state, payload) {
            state.websiteId = payload;
            setStorageItem(STORAGE_KEYS.WEBSITE_ID, payload);
        },
        // 清除用户状态
        CLEAR_USER_STATE: function (state) {
            state.userInfo = null;
            state.accessToken = null;
            state.refreshToken = null;
            removeStorageItem(STORAGE_KEYS.USER_INFO);
            removeStorageItem(STORAGE_KEYS.ACCESS_TOKEN);
            removeStorageItem(STORAGE_KEYS.REFRESH_TOKEN);
        },
        // 保留原有mutations
        SET_THEME: function (state, payload) {
            state.theme = payload;
            setStorageItem(STORAGE_KEYS.THEME, payload);
        },
        SET_LAST_SIGN_IN_DATE: function (state, payload) {
            state.lastSignInDate = payload;
            setStorageItem(STORAGE_KEYS.LAST_SIGN_IN_DATE, payload);
        }
    },
    actions: {
        // 初始化用户信息（从本地存储加载）
        initUserInfo: function (_a) {
            var commit = _a.commit;
            var rememberMe = getStorageItem(STORAGE_KEYS.REMEMBER_ME);
            var loginInfo = getStorageItem(STORAGE_KEYS.LOGIN_INFO);
            var userInfo = getStorageItem(STORAGE_KEYS.USER_INFO);
            var accessToken = getStorageItem(STORAGE_KEYS.ACCESS_TOKEN);
            var refreshToken = getStorageItem(STORAGE_KEYS.REFRESH_TOKEN);
            var theme = getStorageItem(STORAGE_KEYS.THEME);
            var lastSignInDate = getStorageItem(STORAGE_KEYS.LAST_SIGN_IN_DATE);
            if (rememberMe !== null) {
                commit('SET_REMEMBER_ME', rememberMe);
            }
            if (loginInfo) {
                commit('SET_LOGIN_INFO', loginInfo);
            }
            if (userInfo) {
                commit('SET_USER_INFO', userInfo);
            }
            if (accessToken) {
                commit('SET_ACCESS_TOKEN', accessToken);
            }
            if (refreshToken) {
                commit('SET_REFRESH_TOKEN', refreshToken);
            }
            if (theme) {
                commit('SET_THEME', theme);
            }
            if (lastSignInDate) {
                commit('SET_LAST_SIGN_IN_DATE', lastSignInDate);
            }
        },
        // 登录
        login: function (_a, _b) {
            var commit = _a.commit;
            var userInfo = _b.userInfo, tokens = _b.tokens, rememberMe = _b.rememberMe, loginInfo = _b.loginInfo;
            return __awaiter(this, void 0, void 0, function () {
                var today;
                return __generator(this, function (_c) {
                    // 存储记住我状态
                    commit('SET_REMEMBER_ME', !!rememberMe);
                    // 仅当记住我为 true 或未设置时，才存储登录信息
                    if (loginInfo) {
                        if (rememberMe) {
                            // 存储登录信息
                            commit('SET_LOGIN_INFO', loginInfo);
                        }
                        else {
                            // 清除已存储登录信息
                            commit('SET_LOGIN_INFO', null);
                        }
                    }
                    // 存储用户信息
                    commit('SET_USER_INFO', userInfo);
                    // 存储 token
                    if (tokens) {
                        if (tokens.accessToken) {
                            commit('SET_ACCESS_TOKEN', tokens.accessToken);
                        }
                        if (tokens.refreshToken) {
                            commit('SET_REFRESH_TOKEN', tokens.refreshToken);
                        }
                    }
                    today = new Date().toISOString().split('T')[0];
                    commit('SET_LAST_SIGN_IN_DATE', today);
                    return [2 /*return*/, true];
                });
            });
        },
        // 注销
        logout: function (_a) {
            var commit = _a.commit;
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_b) {
                    // 清除用户状态，但保留 rememberMe 设置和主题设置
                    commit('CLEAR_USER_STATE');
                    return [2 /*return*/, true];
                });
            });
        },
        // 更新访问令牌
        updateAccessToken: function (_a, token) {
            var commit = _a.commit;
            commit('SET_ACCESS_TOKEN', token);
        },
        // 更新刷新令牌
        updateRefreshToken: function (_a, token) {
            var commit = _a.commit;
            commit('SET_REFRESH_TOKEN', token);
        },
        // 更新用户信息
        updateUserInfo: function (_a, userInfo) {
            var commit = _a.commit, state = _a.state;
            if (state.rememberMe) {
                commit('SET_USER_INFO', userInfo);
            }
        },
        // 切换主题
        toggleTheme: function (_a) {
            var commit = _a.commit, state = _a.state;
            var newTheme = state.theme === 'light' ? 'dark' : 'light';
            commit('SET_THEME', newTheme);
            return newTheme;
        },
        // 设置主题
        setTheme: function (_a, theme) {
            var commit = _a.commit;
            commit('SET_THEME', theme);
        },
        // 用户签到
        signIn: function (_a) {
            var commit = _a.commit;
            var today = new Date().toISOString().split('T')[0];
            commit('SET_LAST_SIGN_IN_DATE', today);
            return today;
        },
        // 检查今天是否已签到
        checkSignInToday: function (_a) {
            var state = _a.state;
            var today = new Date().toISOString().split('T')[0];
            return state.lastSignInDate === today;
        }
    }
});
